exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrapper{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;height:100%;overflow-x:hidden;overflow-y:hidden}.popImage{padding:20px}.popContent{width:100%;text-align:center;font-size:20px;font-weight:700;color:#ffc116}.van-popup--center.van-popup--round{border-radius:16px;background-color:transparent}.block{width:120px;height:120px;background-color:#fff}", ""]);

// exports
